<template>
  <v-card id="table-firebase">
    <v-card-title id="card-title" ref="card-title">
      <v-checkbox
        :value="selectedAll"
        color="#6ec39b"
        class="btn-choose"
        :label="`เลือก ${selectedList.length} ฉบับ `"
        @change="clickSelectedAll($event)"
      ></v-checkbox>

      <button
        v-if="selectedList?.length > 0"
        class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
        style="font-size: 0.875rem"
        @click="clearAllSelectList"
      >
        ยกเลิกการเลือก
      </button>

      <v-btn
        text
        :color="
          selectedList.filter((x) => !x.xmlUrl).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="downloadXML"
        :disabled="
          selectedList.length < 1 ||
          downloadingXml ||
          selectedList.filter((x) => x.xmlUrl).length < 1
        "
        :loading="downloadingXml"
      >
        <img
          :src="
            selectedList.filter((x) => !x.xmlUrl).length > 0 &&
            selectedList.filter((x) => x.xmlUrl).length >= 1
              ? '/images/icons/icon_download_xml_red.svg'
              : '/images/icons/icon_download_xml.svg'
          "
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span
          >ดาวน์โหลด XML
          {{ `(${selectedList.filter((x) => x.xmlUrl).length})` }}</span
        >
        <template v-if="downloadStatus.xml.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.xml.progress }}</span>
        </template>
      </v-btn>
      <v-btn
        text
        :color="
          selectedList.filter((x) => !x.pdfUrl).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="downloadPDF"
        :disabled="
          selectedList.length < 1 ||
          downloadingPdf ||
          selectedList.filter((x) => x.pdfUrl).length < 1
        "
        :loading="downloadingPdf"
      >
        <img
          :src="
            selectedList.filter((x) => !x.xmlUrl).length > 0 &&
            selectedList.filter((x) => x.xmlUrl).length >= 1
              ? '/images/icons/icon_download_pdf_red.svg'
              : '/images/icons/icon_download_pdf.svg'
          "
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span
          >ดาวน์โหลด PDF
          {{ `(${selectedList.filter((x) => x.pdfUrl).length})` }}</span
        >
        <template v-if="downloadStatus.pdf.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.pdf.progress }}</span>
        </template>
      </v-btn>
      <v-btn
        text
        color="#6ec39b"
        @click.prevent="monthlyDownloadDialog = true"
        :disabled="downloadStatus.monthly.downloading"
        :loading="downloadStatus.monthly.downloading"
      >
        <img
          src="/images/icons/icon_download_pdf.svg"
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span>ดาวน์โหลด รายเดือน </span>
        <template v-if="downloadStatus.monthly.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.monthly.progress }}</span>
        </template>
      </v-btn>
      <monthly-download-dialog
        :companyID="companyID"
        :documentTypeKey="documentTypeKey"
        v-model="monthlyDownloadDialog"
        @confirm="downloadMonthly"
      />

      <v-dialog v-model="emailDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              :disabled="isBtnDisabled || selectedList.length <= 0"
              @click="getEmailList"
              text
              @mouseover="selectedList.length > 0 ? (sentEmailHover = true) : null"
              @mouseleave="selectedList.length > 0 ? (sentEmailHover = false) : null"
              v-bind="attrs"
              v-on="on"
              class="tw-px-4 tw-py-2 tw-rounded-md tw-relative"
              style="font-size: 0.875rem"
              v-bind:class="(!isBtnDisabled && selectedList.length > 0) ? 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white' : 'disabled-btn'"
            >
              <img
                src="/images/icons/icon _send_email.svg"
                class="tw-float-left tw-mr-2"
                v-if="!sentEmailHover"
              />
              <img
                src="/images/icons/icon _send_email_white.svg"
                class="tw-float-left tw-mr-2"
                v-if="sentEmailHover"
              />
              ส่งอีเมล
            </v-btn>


        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งอีเมล</b>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row v-for="(v, k) in emailList" v-bind:key="k">
                    <v-col style="max-width: 25%">{{ k }}</v-col>
                    <v-col>
                      <v-autocomplete
                        :ref="'autocomplete' + k"
                        v-model="emailList[k]"
                        :items="emailList[k]"
                        :rules="emailRules"
                        outlined
                        dense
                        chips
                        deletable-chips
                        small-chips
                        label="กรุณากรอกอีเมล"
                        multiple
                        hide-selected
                        append-icon
                        hide-no-data
                        @keydown.tab.prevent="
                          autocompleteAddEmail(k, $event.target.value)
                        "
                        @keydown.enter.prevent="
                          autocompleteAddEmail(k, $event.target.value)
                        "
                        :search-input.sync="emailInput"
                        @blur="autocompleteAddEmail(k, $event.target.value)"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="max-width: 25%">อีเมล template</v-col>
                    <v-col>
                      <v-select
                        v-model="mEmailTemplateID"
                        :items="mEmailTemplatesIDList"
                        label="Email Template ID"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="clearEmailList"
                  :disabled="sendEmailLoading"
                >
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  :disabled="sendEmailLoading"
                  @click="validateEmail"
                >
                  <img
                    src="/images/icons/icon_send_email.svg"
                    style="max-height: 26px; max-width: 26px"
                    class="mr-2"
                  />
                  <b>ส่งอีเมล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>
      <!-- minToDate:: {{ minToDate }} -->
      <v-dialog v-model="exportDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <button
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
            style="font-size: 0.875rem"
          >
            ส่งออกข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งออกข้อมูล</b>
              </v-card-title>
              <v-card-text>
                <v-menu
                  v-model="menuDatePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportStart"
                      label="วันที่เอกสารเริ่มต้น"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportStart"
                    @input="menuDatePickerStart = false"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menuDatePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportEnd"
                      label="วันที่เอกสารสิ้นสุด"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportEnd"
                    @input="menuDatePickerEnd = false"
                  ></v-date-picker>
                </v-menu>
                <v-radio-group v-model="exportEmailStatusRadios" row>
                  <template v-slot:label>
                    <div>สถานะการส่งอีเมล</div>
                  </template>
                  <v-radio value="All">
                    <template v-slot:label>
                      <div>ทั้งหมด</div>
                    </template>
                  </v-radio>
                  <v-radio value="Sent">
                    <template v-slot:label>
                      <div>ส่งแล้ว</div>
                    </template>
                  </v-radio>
                  <v-radio value="NotSent">
                    <template v-slot:label>
                      <div>ยังไม่ส่ง</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelExportDialog">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  @click="exportDocs"
                >
                  <b>ส่งออกข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <v-dialog v-model="importDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <button
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
            style="font-size: 0.875rem"
          >
            นำเข้าข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>นำเข้าข้อมูล</b>
              </v-card-title>
              <v-container v-if="alert.show && alert.showOnDialog == true">
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      v-model="alert.show"
                      :type="alert.type"
                      transition="scale-transition"
                      dismissible
                      >{{ alert.text }}</v-alert
                    >
                  </v-col>
                </v-row>
              </v-container>
              <v-card-text>
                <v-radio-group
                  v-if="companyDetail.uploadTemplate2File"
                  v-model="selectedTemp"
                  inline
                >
                  <div class="flex-row d-flex bg-surface-variant">
                    <v-sheet class="ma-2 pa-2">
                      <v-radio
                        label="เทมเพลต 1"
                        value="template-1"
                        id="template-1"
                        @click="handleTemp('template-1')"
                      ></v-radio>
                    </v-sheet>
                    <v-sheet class="ma-2 pa-2">
                      <v-radio
                        label="เทมเพลต 2"
                        value="template-2"
                        id="template-2"
                        @click="handleTemp('template-2')"
                      ></v-radio>
                    </v-sheet>
                  </div>
                </v-radio-group>
                <div
                  class="tmp-1"
                  :style="{ display: temp1Hiden ? 'none' : 'block' }"
                >
                  <label> </label>
                  <v-file-input
                    ref="importFileRef"
                    v-model="template1"
                    clearable
                    label="File input"
                    color="primary"
                    filled
                    prepend-icon="mdi-paperclip"
                    placeholder="Select your file"
                    @change="handleImportFile"
                    accept=".csv"
                  ></v-file-input>
                </div>
                <div
                  class="tmp-2"
                  :style="{ display: temp2Hiden ? 'none' : 'block' }"
                >
                  <label>ส่วนหัว</label>
                  <v-file-input
                    ref="importFileRefH"
                    v-model="templateh"
                    label="File input"
                    color="primary"
                    filled
                    prepend-icon="mdi-paperclip"
                    placeholder="Select your file"
                    @change="handleImportFileTemp2('head', $event)"
                    accept=".csv"
                  ></v-file-input>
                  <label>ส่วนเนื้อใน</label>
                  <v-file-input
                    ref="importFileRefL"
                    v-model="templatel"
                    label="File input"
                    color="primary"
                    filled
                    prepend-icon="mdi-paperclip"
                    placeholder="Select your file"
                    @change="handleImportFileTemp2('line', $event)"
                    accept=".csv"
                  ></v-file-input>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelImportDialog">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  @click="importDocs"
                >
                  <b>นำเข้าข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>
      <v-btn
        text
        :color="
          selectedList.filter((x) => !x.downloadedXml).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="() => clearDownloadedXml()"
        :disabled="
          selectedList.length < 1 ||
          clearingDownloadedXml ||
          selectedList.filter((x) => x.downloadedXml).length < 1
        "
        :loading="clearingDownloadedXml"
      >
        <span
          >ยกเลิกค่าดาวน์โหลด
          {{ `(${selectedList.filter((x) => x.downloadedXml).length})` }}</span
        >
      </v-btn>

      <!-- //TaxRIS -->

      <v-dialog
        v-if="
          companyID == 'CULzXZyT4RRHP1cHB0Uy' ||
          companyID == 'GoMBP30inwwbyosHZwH3' ||
          companyID == 'gWur0KlJ1ghdvuGm3ZqZ' ||
          companyID == 'GInPVDniT27QxnWYYEqG'
        "
        v-model="taxRisDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            :disabled="selectedList.length <= 0"
            @mouseover="
              selectedList.length > 0 ? (sentTaxRisHover = true) : null
            "
            @mouseleave="
              selectedList.length > 0 ? (sentTaxRisHover = false) : null
            "
            @click="getTaxRisList"
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative"
            style="font-size: 0.875rem"
            v-bind:class="
              selectedList.length > 0
                ? 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white'
                : 'disabled-btn'
            "
          >
            <img
              src="/images/icons/invoice_la.png"
              height="26px"
              width="26px"
              class="tw-float-left tw-mr-2"
              v-show="!sentTaxRisHover"
            />
            <img
              src="/images/icons/invoice_la_white.png"
              class="tw-float-left tw-mr-2"
              height="26px"
              width="26px"
              v-show="sentTaxRisHover"
            />
            <span>ส่งกรมสรรพากรลาว ({{ selectedList.length }})</span>
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="taxRisValid">
            <v-card>
              <v-card-title>
                <div class="tw-flex tw-gap-2">
                  ส่งกรมสรรพากรลาว
                  <img
                    src="/images/icons/lao_tax.jpg"
                    height="26px"
                    width="26px"
                  />
                </div>
              </v-card-title>
              <div class="tw-px-6 tw-pb-6">
                <div
                  class="tw-py-2 tw-border-t tw-flex tw-border-l tw-border-gray tw-border-r tw-pl-2"
                >
                  <div
                    class="tw-border-r tw-pr-2 tw-mr-2 tw-border-gray numberRow"
                  >
                    ลำดับ
                  </div>
                  <div>เลขที่เอกสาร</div>
                </div>
                <div v-for="(item, index) in taxRisList" :key="item.docID">
                  <div
                    :class="{
                      'tw-border-t': index == 0,
                      'tw-py-2 tw-border-b tw-flex tw-border-l tw-border-gray tw-border-r tw-pl-2': true,
                    }"
                  >
                    <div
                      class="tw-border-r tw-pr-2 tw-mr-2 tw-border-gray numberRow"
                    >
                      {{ index + 1 }}
                    </div>
                    <div>{{ item["docID"] }}</div>
                  </div>
                </div>
                <div class="tw-pt-4">จำนวนเอกสาร: {{ taxRisList.length }}</div>
              </div>              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="clearTaxRisList"
                  :disabled="sendTaxRisLoading || exportingToExcel"
                >
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <!-- <v-btn
                  :disabled="sendTaxRisLoading || exportingToExcel"
                  class="btn-submit"
                  color="#2196F3"
                  text
                  type="button"
                  @click="exportToExcel"
                >
                  <v-icon class="mr-2">mdi-file-excel</v-icon>
                  <b v-show="!exportingToExcel">Export report to excel</b>
                  <b v-show="exportingToExcel">กำลังสร้าง Excel...</b>
                </v-btn> -->
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  :disabled="sendTaxRisLoading || exportingToExcel"
                  @click="sendTaxRIS"
                >
                  <img
                    src="/images/icons/invoice_la.png"
                    style="max-height: 26px; max-width: 26px"
                    class="mr-2"
                  />
                  <b v-show="!sendTaxRisLoading">ส่ง</b>
                  <b v-show="sendTaxRisLoading">กำลังส่ง</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <div class="tw-flex tw-items-center">
        <popover-menu
          style="padding-right: 20px"
          buttonText="กรอง"
          titleText="แสดงเอกสารเฉพาะ"
          :option-list="optionFilterList"
          :value-list="valueFilterList"
          @change-value-filter-list="onChangeValueFilterList"
          buttonIcon="/images/icons/icon_filter.svg"
          :defaultListItem="defaultValueFilterList"
        ></popover-menu>

        <popover-menu
          style="padding-right: 20px"
          buttonText="ซ่อน"
          titleText="เลือกคอลัมน์ที่ต้องการซ่อน"
          :option-list="optionHideList"
          :value-list="valueHideList"
          @change-value-filter-list="onChangeValueDropdownHideColumn"
          buttonIcon="/images/icons/icon_hidden.svg"
          :defaultListItem="defaultValueHideList"
        ></popover-menu>

        <popover-menu-radio
          style="padding-right: 20px"
          buttonText="ตั้งค่าการค้นหา"
          titleText="เลือกคอลัมน์ที่ต้องการค้นหา"
          :option-list="searchOptionList"
          @change-value-option="onChangeValueSearchOption"
          buttonIcon="/images/icons/icon_search_setting.svg"
          :defaultValue="defaultSearchOptionValue"
        ></popover-menu-radio>

        <div
          v-if="defaultSearchOptionValue != 'ED.IssueDateTime'"
          class="search-box"
        >
          <v-text-field
            :value="keyword"
            :label="`ค้นหา จาก ${
              searchOptionList?.find(
                (item) => item.key === defaultSearchOptionValue
              )?.label
            }`"
            append-icon="mdi-magnify"
            :placeholder="`ค้นหา จาก ${
              searchOptionList?.find(
                (item) => item.key === defaultSearchOptionValue
              )?.label
            }`"
            outlined
            @input="debounceInput"
          ></v-text-field>
        </div>

        <div
          v-if="defaultSearchOptionValue == 'ED.IssueDateTime'"
          class="tw-flex tw-gap-4"
        >
          <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="292px"
            min-width="292px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="จากวันที่เอกสาร"
                append-icon="mdi-calendar-month-outline"
                readonly
                :value="fromDateDisp"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              locale="en-in"
              v-model="fromDateVal"
              no-title
              @input="fromDateMenu = false"
              :min="minDate"
            ></v-date-picker>
          </v-menu>

          <v-menu
            v-model="toDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="292px"
            min-width="292px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="ถึงวันที่"
                append-icon="mdi-calendar-month-outline"
                readonly
                :value="toDateDisp"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              locale="en-in"
              v-model="toDateVal"
              no-title
              @input="toDateMenu = false"
              :min="minToDate"
            ></v-date-picker>
          </v-menu>

          <v-btn
            text
            color="#f05d5d"
            type="button"
            outlined
            class="btn-submit tw-self-center"
            @click="resetDateSearch"
          >
            <v-icon small>mdi-restart</v-icon>
            <b>รีเซ็ตค่า</b>
          </v-btn>
        </div>
      </div>
    </v-card-title>

    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-model="alert.show"
            :type="alert.type"
            transition="scale-transition"
            dismissible
            >{{ alert.text }}</v-alert
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- docs::
    {{
    docs.length
     }} -->

    <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr id="header-table">
            <th />
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('ED.IssueDateTime')"
              v-if="[
                showColumn('ED.IssueDateTime'),
                defaultOrder('ED.IssueDateTime'),
              ]"
            >
              วันที่เอกสาร
              <img
                v-if="orderBySelect['key'] === 'ED.IssueDateTime'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'ED.IssueDateTime'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('objectID')"
            >
              เลขที่เอกสาร
              <img
                v-if="orderBySelect['key'] === 'objectID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'objectID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.ID')"
              v-if="showColumn('SCTT.AHTA.BTP.ID')"
            >
              รหัสผู้ซื้อ
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.ID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.ID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.Name')"
              v-if="showColumn('SCTT.AHTA.BTP.Name')"
            >
              ชื่อผู้ซื้อ / ชื่อบริษัท
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.Name'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.Name'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.STR.ID')"
              v-if="showColumn('SCTT.AHTA.BTP.STR.ID')"
            >
              เลขผู้เสียภาษี
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.STR.ID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.STR.ID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('@BuyerBranchID')"
              v-if="showColumn('@BuyerBranchID')"
            >
              สาขาผู้ซื้อ
              <img
                v-if="orderBySelect['key'] === '@BuyerBranchID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@BuyerBranchID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
            >
              มูลค่าที่นำมาคิดภาษี
              <img
                v-if="
                  orderBySelect['key'] ===
                  'SCTT.AHTS.STSHMS.TaxBasisTotalAmount'
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !==
                  'SCTT.AHTS.STSHMS.TaxBasisTotalAmount'
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.TaxTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxTotalAmount')"
            >
              ภาษีมูลค่าเพิ่ม
              <img
                v-if="
                  orderBySelect['key'] === 'SCTT.AHTS.STSHMS.TaxTotalAmount' &&
                  !keyword
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !== 'SCTT.AHTS.STSHMS.TaxTotalAmount' &&
                  !keyword
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.GrandTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.GrandTotalAmount')"
            >
              ยอดรวม
              <img
                v-if="
                  orderBySelect['key'] === 'SCTT.AHTS.STSHMS.GrandTotalAmount'
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !== 'SCTT.AHTS.STSHMS.GrandTotalAmount'
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('@TimeSignedXml')"
              v-if="showColumn('@TimeSignedXml')"
            >
              เวลาลงลายมือชื่อ
              <img
                v-if="orderBySelect['key'] === '@TimeSignedXml'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@TimeSignedXml'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-center"
              style="min-width: 80px"
              v-if="showColumn('xmlAndEmail')"
            >
              สถานะเอกสารและอีเมล
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docs" :key="doc.id" class="tr-data">
            <td>
              <v-checkbox
                color="#6ec39b"
                :input-value="getCheckedSelect(doc.id)"
                class="remove-checkbox-padding"
                @change="clickSelected(doc)"
              ></v-checkbox>
            </td>
            <td
              v-if="showColumn('ED.IssueDateTime')"
              :disabled="downloadPdfLoading"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div class="check-box-flex">
                <img
                  v-if="doc['@DownloadedXml']"
                  src="/images/icons/icon_downloaded.svg"
                  alt="downloaded"
                  class="icon-downloaded"
                />
                <img
                  v-if="doc['@DocSent']"
                  src="/images/icons/icon_taxris_send.png"
                  alt="doc sent icon"
                  class="icon-downloaded"
                />
                <span>{{ getDateWithFormat(doc["ED.IssueDateTime"]) }}</span>
              </div>
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["objectID"] }}
            </td>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.ID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["SCTT.AHTA.BTP.ID"] || "-" }}
            </td>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.Name')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["SCTT.AHTA.BTP.Name"] }}
            </td>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.STR.ID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ getTaxId(doc["SCTT.AHTA.BTP.STR.ID"], companyID) }}
            </td>
            <td
              v-if="showColumn('@BuyerBranchID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["@BuyerBranchID"] || "-" }}
            </td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
              v-html="
                getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxBasisTotalAmount'])
              "
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxTotalAmount')"
              v-html="getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxTotalAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.GrandTotalAmount')"
              v-html="getFormatAmount(doc['SCTT.AHTS.STSHMS.GrandTotalAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-left"
              v-if="showColumn('@TimeSignedXml')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ timeFormat(doc["@TimeSignedXml"]) || "-" }}
            </td>
            <td
              class="text-center"
              v-if="showColumn('xmlAndEmail')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div
                style="
                  width: 40px;
                  display: flex;
                  justify-content: space-between;
                  margin: 0 auto;
                "
              >
                <v-icon
                  dark
                  small
                  color="#6ec39b"
                  v-if="doc['@SignedXmlUrl'] !== ''"
                  >mdi-check-circle-outline</v-icon
                >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dark
                      small
                      color="#c9242b"
                      alt="cancel-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@DocData']?.['docStatus'] == 'C'"
                      >mdi-cancel</v-icon
                    >
                  </template>
                  <span>เอกสารใบนี้ถูกยกเลิก</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      width="16px"
                      height="14px"
                      src="/images/icons/icon_status_error.svg"
                      alt="error-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@Errors'] && doc['@Errors'].length > 0"
                      class="icon-button"
                    />
                  </template>
                  <span>{{
                    doc["@Errors"]
                      ? errorsMessage(doc["@Errors"]).split(",").join(", ")
                      : ""
                  }}</span>
                </v-tooltip>


                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dark
                      small
                      color="#707070"
                      alt="cancel-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@MailSent']"
                      >mdi-email-outline</v-icon
                    >
                  </template>
                  <span>{{
                    timeFormat(doc["@TimeMailSent"])
                  }}</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div
      v-if="docs.length == 0 && !loading"
      class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
    >
      <h2>ไม่พบเอกสารที่ต้องการ</h2>
    </div>
    <v-progress-linear
      indeterminate
      color="green"
      :active="loading || downloadPdfLoading"
    ></v-progress-linear>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import docs from "@/store/collection/docs";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import isMobile from "../../../libs/detectMobile";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");
import PopoverMenu from "./popoverMenu";
import PopoverMenuRadio from "./popoverMenuRadio";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import getErrorMessage from "@/libs/getErrorMessage";
// import { docsQuery } from "../../../store/collection/docs";
import companyStatus from "@/libs/companyStatus";
import router from "@/router";
import getDocumentTypeKey from "@/libs/getDocumentTypeKey";
import libCSV from "@/libs/libCSV";
import MonthlyDownloadDialog from "./monthly-download-dialog.vue";
import Papa from "papaparse";
import * as XLSX from 'xlsx';

const axios = require("axios");
const _ = require("lodash");

const MAX_DOC_PER_ZIP = {
  xml: 500,
  pdf: 100,
};


export default {
  components: {
    PopoverMenu,
    PopoverMenuRadio,
    MonthlyDownloadDialog,
  },
  data() {
    return {
      companyID: this.$route.params.companyId,
      fromDateMenu: false,
      fromDateVal: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      //check file
      // template import data
      selectedTemp: "template-1",
      temp1Hiden: false,
      template1: null,
      templateh: null,
      templatel: null,
      temp2Hiden: true,
      //end template import data
      selectedAll: false,
      emailDialog: false,
      taxRisDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailValid: false,
      taxRisValid: false,      sendEmailLoading: false,
      sendTaxRisLoading: false,
      exportingToExcel: false,
      sendEmailSuccessCount: 0,
      sendTaxRisSuccessCount: 0,
      mEmailTemplateID: "Default Template",
      mEmailTemplatesListUnsubscribeObject: null,
      mEmailTemplatesList: [],
      mEmailTemplatesIDList: [],
      alert: {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      },
      // alert: {
      //   text: "",
      //   type: "success",
      //   show: false
      // },
      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      clearingDownloadedXml: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
        { label: "เอกสารที่ยกเลิก", key: "cancelled" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "วันที่เอกสาร", key: "ED.IssueDateTime" },
        { label: "รหัสผู้ซื้อ", key: "SCTT.AHTA.BTP.ID" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "SCTT.AHTA.BTP.Name" },
        { label: "เลขผู้เสียภาษี", key: "SCTT.AHTA.BTP.STR.ID" },
        { label: "สาขาผู้ซื้อ", key: "@BuyerBranchID" },
        {
          label: "มูลค่าที่นำมาคิดภาษี",
          key: "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        },
        { label: "ภาษีมูลค่าเพิ่ม", key: "SCTT.AHTS.STSHMS.TaxTotalAmount" },
        { label: "ยอดรวม", key: "SCTT.AHTS.STSHMS.GrandTotalAmount" },
        { label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
        { label: "สถานะเอกสารและอีเมล", key: "xmlAndEmail" },
      ],
      valueHideList: [
        "all",
        "ED.IssueDateTime",
        "SCTT.AHTA.BTP.ID",
        "SCTT.AHTA.BTP.Name",
        "SCTT.AHTA.BTP.STR.ID",
        "@BuyerBranchID",
        "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        "SCTT.AHTS.STSHMS.TaxTotalAmount",
        "SCTT.AHTS.STSHMS.GrandTotalAmount",
        "@TimeSignedXml",
        "xmlAndEmail",
      ],
      defaultValueHideList: [
        "all",
        "ED.IssueDateTime",
        "SCTT.AHTA.BTP.ID",
        "SCTT.AHTA.BTP.Name",
        "SCTT.AHTA.BTP.STR.ID",
        "@BuyerBranchID",
        "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        "SCTT.AHTS.STSHMS.TaxTotalAmount",
        "SCTT.AHTS.STSHMS.GrandTotalAmount",
        "@TimeSignedXml",
        "xmlAndEmail",
      ],
      searchOptionList: [
        { label: "วันที่เอกสาร", key: "ED.IssueDateTime" },
        { label: "เลขที่เอกสาร", key: "objectID" },
        { label: "รหัสผู้ซื้อ", key: "SCTT.AHTA.BTP.ID" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "SCTT.AHTA.BTP.Name" },
        { label: "เลขผู้เสียภาษี", key: "SCTT.AHTA.BTP.STR.ID" },
        { label: "สาขาผู้ซื้อ", key: "@BuyerBranchID" },
        {
          label: "มูลค่าที่นำมาคิดภาษี",
          key: "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        },
        { label: "ภาษีมูลค่าเพิ่ม", key: "SCTT.AHTS.STSHMS.TaxTotalAmount" },
        { label: "ยอดรวม", key: "SCTT.AHTS.STSHMS.GrandTotalAmount" },
        //{ label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
      ],
      defaultSearchOptionValue: "objectID",
      disablePopOver: false,
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },

      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"), // hardcode for auto case
      first:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      taxRisList: [],
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,
      sentTaxRisHover: false,
      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      dateExportStart: "",
      dateExportEnd: "",

      // monthly pdf
      monthlyDownloadDialog: false,
      exportEmailStatusRadios: "All",
      importDialog: false,
      importFile: [],
      importFileTemp2: [],
      importFileTemp2Head: [],
      importFileTemp2Line: [],
      documentTypeKey: "",
      currentXmlUrl: null,
    };
  },
  created() {
    this.query();
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.handleResize, 100);
    });
    this.handleResize();
    this.loadEmailTemplateList();
    //uploadtemplate
    this.$store.dispatch("companies/getCompany", {
      companyID: this.companyID,
    });
    let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        this.documentTypeKey = getDocumentTypeKey(documentType[documentType.length - 1]);
      }
  },
  beforeDestroy() {
    this.$store.dispatch("docs/getDocListUnsubscribe");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState({
      docs: (state) => state.docs.list,
      loading: (state) => state.docs.loading,
      // page: state => state.docs.page,
      keyword: (state) => state.docs.keyword,
      downloaded: (state) => state.docsDownloaded.downloaded,
      downloadingXml: (state) => state.docsDownloaded.downloadingXml,
      downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
      downloadStatus: (state) => state.docsDownloaded.downloadStatus,
      selectedBranch: (state) => state.companies.selectedBranch,
      orderBySelect: (state) => state.docs.orderBySelect,
      valueFilterList: (state) => state.docs.valueFilterList,
      selectedList: (state) => state.docs.selectedList,
      showPaginationTemplate: (state) => state.docs.showPaginationTemplate,
      companyStatus: (state) => state.statusesByCompany.companyStatus,
      globalLoading: (state) => state.loading.globalLoading,
      summaryAll: (state) => state.docs.summaryAll,
      companyDetail: (state) => state.companies.companyDetail,
    }),
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
    isBtnDisabled() {
    return !this.selectedList.some(item => item.xmlUrl && item.xmlUrl.trim() !== '');
  }

  },

  watch: {
    defaultSearchOptionValue: {
      handler: function () {
        this.$store.dispatch("docs/setFromDate", "");
        this.$store.dispatch("docs/setToDate", "");
        this.$store.dispatch("docs/updateKeyword", "");
        this.clearValue();
        this.clearSelectList();
        this.fromDateVal = null;
        this.toDateVal = null;
        this.query();
      },
    },
    selectedBranch: {
      handler: function () {
        this.query();
      },
    },
    fromDateVal: {
      handler: function () {
        this.$store.dispatch("docs/setFromDate", this.fromDateVal);
        if (this.fromDateVal !== "") {
          this.query();
        }
      },
    },
    toDateVal: {
      handler: function () {
        this.$store.dispatch("docs/setToDate", this.toDateVal);
        if (this.toDateVal !== "") {
          this.query();
        }
      },
    },
    $route() {
      this.clearValue();
      this.query();
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        this.documentTypeKey = getDocumentTypeKey(documentType[documentType.length - 1]);
      }
      if(documentType.length === 2) {
        this.documentTypeKey = ""
      }
    },
    valueFilterList: {
      handler: function () {
        this.query();
      },
    },
    selectedList: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    docs: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    height: {
      handler: function () {
        this.matchHeight();
      },
    },
  },
  // methods: {
  //   loadMore() {},
  //     }
  //   },

  // },
  methods: {
    formatedDateTaxRIS(inputDate) {
      try {
        // Parse the input date-time string using Moment.js
        const dt = moment(inputDate);

        // Format the date using Moment.js
        const outputDate = dt.format("YYYYMMDD");

        return outputDate;
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    },
    async sendTaxRISs() {
      try {
        // request header config

        // get user token
        let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function (idToken) {
            return idToken;
          });

        const header = {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            // Authorization:
            //   "JWT private-token-for-admin-to-send-email-ueuwpmv392nd2n3nv93nnsnc82b83nzx",
            Authorization: "JWT " + token,
          },
        };
        //-- dev
        // const APIendPoint =
        //   "http://localhost:5000/sld-etax/us-central1/sendDoc";

        //-- production
        const APIendPoint =
          "https://us-central1-sld-etax.cloudfunctions.net/sendDoc";
        const payloads = this.selectedList;
        console.log("payload ==> ", payloads);

        for (const payload of payloads) {
          await axios.post(APIendPoint, payload, header);
        }

        console.log("Response:", "Sent Document Successfully");
      } catch (error) {
        console.error("Error:", error);
      }
    },
    sendTaxRIS: async function () {
      this.sendTaxRisLoading = true;

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };

      //dev
      // const APIendPoint = "http://localhost:5000/sld-etax/us-central1/sendDoc";
      //production
      const APIendPoint =
        "https://us-central1-sld-etax.cloudfunctions.net/sendDoc";

      const promises = this.taxRisList.map(async (item) => {
        let data = item;

        await axios.post(APIendPoint, data, { headers }).then(
          (response) => {
            if (response.status === 200) {
              this.sendTaxRisSuccessCount += 1;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });

      await Promise.all(promises);
      console.log(
        "this.sendTaxRisSuccessCount:: ",
        this.sendTaxRisSuccessCount
      );
      if (this.sendTaxRisSuccessCount === this.selectedList.length) {
        this.alert = {
          text: "ส่งเอกสารสำเร็จ " + this.sendTaxRisSuccessCount + " รายการ",
          type: "success",
          show: true,
        };

        this.sendTaxRisSuccessCount = 0;

        this.query();
      }
      this.sendTaxRisLoading = false;
      this.taxRisDialog = false;
      this.taxRisList = [];
    },
    handleTemp(option) {
      this.selectedTemp = option;
      switch (option) {
        case "template-1":
          this.temp2Hiden = true;
          this.temp1Hiden = false;

          break;
        case "template-2":
          this.temp1Hiden = true;
          this.temp2Hiden = false;
          break;
        default:
          this.temp2Hiden = false;
          break;
      }
      // console.log(`Clicked on ${option} and ${this.selectedTemp}`);
    },
    loadEmailTemplateList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        if (this.mEmailTemplatesListUnsubscribeObject) {
          this.mEmailTemplatesListUnsubscribeObject();
        }
        this.mEmailTemplatesListUnsubscribeObject = fc.db
          .collection(`Companies/${companyId}/EmailTemplates`)
          .onSnapshot((docs) => {
            this.mEmailTemplatesList = [];
            this.mEmailTemplatesIDList = ["Default Template"];

            docs.forEach((doc) => {
              const data = doc.data();
              data.id = doc.id;
              this.mEmailTemplatesList.push(data);
              this.mEmailTemplatesIDList.push(data.id);
            });
            // console.log(this.mEmailTemplatesList)
          });
      }
    },
    startDrag() {
      this.timer = false;
      this.dragging = false;
      this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        this.onClickDocId(doc);
      }
      this.dragging = false;
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true;
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return;
      let cardTitle = document.getElementById("card-title").clientHeight || 0;
      let headerTable =
        document.getElementById("header-table").clientHeight || 0;
      let rowDetailRow = Math.floor(
        (this.height - (150 + cardTitle + headerTable)) / 67
      );
      let pageLimit = 10;
      pageLimit =
        rowDetailRow > 1
          ? rowDetailRow - 1
          : rowDetailRow >= 0
          ? rowDetailRow
          : 1;

      localStorage.setItem("pageLimitAuto", pageLimit.toString());
      this.$store.dispatch("user/setPageLimitAutoChange");
      this.clearValue();
      this.query();
    },
    handleResize() {
      this.height = window.innerHeight;
    },
    getTaxId: function (taxID, companyID) {
      if (!taxID || taxID == "N/A")
        return companyID == "XMigdx2tCoT0CD4JDkGN" ||
          companyID == "0m2cwidBErAKMf2I9vkT"
          ? ""
          : "N/A";
      let taxIDShow = "-";
      if (taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13);
      } else if (taxID.length <= 13) {
        taxIDShow = taxID;
      }
      return taxIDShow;
    },
    getCheckedSelect: function (docID) {
      return this.selectedList.some((x) => x["docID"] === docID);
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount);
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("docs/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        });
      }
    },
    getEmailList: function () {
      for (let e of this.selectedList) {
        console.log('e ::: ', e)
        if(!e.xmlUrl){

          continue;
        }
        if (e.docID) {
          if (!this.emailList[e.docID]) {
            this.emailList[e.docID] = [];
          }
          if (e.buyerEmail) {
            this.emailList[e.docID] = Vue.observable(
              e.buyerEmail.replaceAll(";", ",").split(",")
            );
          } else {
            this.emailList[e.docID] = Vue.observable([]);
          }
        }

        console.log(this.emailList);
      }
    },
    getTaxRisList: function () {
      this.taxRisList = this.selectedList;
    },
    clearEmailList: function () {
      this.emailDialog = false;
      this.emailList = {};
    },    clearTaxRisList: function () {
      this.taxRisDialog = false;
      this.taxRisList = [];
    },
    exportToExcel: async function () {
      this.exportingToExcel = true;
      
      try {
        // Create JSON data from taxRisList
        const excelData = this.taxRisList.map(item => ({
          TIN: item["SCTT.AHTA.BTP.STR.ID"] || "123456",
          Name: item["SCTT.AHTA.BTP.Name"] || "SLD Company",
          No: item["objectID"] || "",
          Dated: this.formatedDateTaxRIS(item["ED.IssueDateTime"]) || "",
          Description: "ขายสินค้า", // Default description, you can modify as needed
          ExemptedDomestic: 0,
          ExemptedAbroad: 0,
          NoneVATCollection: 0,
          VAT0Domestic: 0,
          VAT0Abroad: 0,
          VAT10Domestic: parseFloat(item["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]) || 0,
          VAT10Abroad: 0,
          Total: parseFloat(item["SCTT.AHTS.STSHMS.GrandTotalAmount"]) || 0,
          VATCollected: parseFloat(item["SCTT.AHTS.STSHMS.TaxTotalAmount"]) || 0
        }));
        console.log("excelData:: ", excelData);
        // Get user token
        let token =  'Nx5QBXe7pSGan5nF=sh2/FrPPnUsJHJb6U/112H8JUyY1tLYRg5PpTQfJ=a!o-Gb5X-!hHzF1ByVCH?4FJ!i1RTz=4djq9kexNAZI8Ej-cELSjGNuhrvT=GFosLykS0jcs!!ENzSmFhPhnpDy-z1ZhgVduxCZaW/xizqPJ32vrpS7BJlHK8?Xxs33eMAw!n!Src=rbRPD3y3K!3xS5XFJVmQwNTabrQzzMGvQ5h8qE1mxx46IhMS=s6BoZMkskcz';

        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        // Call API to generate Excel
        const response = await axios.post(
          "https://us-central1-sld-etax.cloudfunctions.net/apiGenerateVATOutputExcel",
          excelData,
          { headers }
        );
        console.log("response:: ", response);
        if (response.data && response.data.file) {
          // Convert base64 to blob and download
          const base64Data = response.data.file;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { 
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
          });

          // Create download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `VAT_Output_Report_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.alert = {
            text: "ส่งออกรายงาน Excel สำเร็จ",
            type: "success",
            show: true,
          };
        }
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.alert = {
          text: "เกิดข้อผิดพลาดในการส่งออกรายงาน Excel",
          type: "error",
          show: true,
        };
      } finally {
        this.exportingToExcel = false;
      }
    },
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }
      return "";
    },
    getDocsByRange(timeStart, timeEnd) {
      const companyID = this.$route.params.companyId;
      let documentType = this.getDocumentType();
      // console.log("documentType:: ", documentType);
      let documentTypeNumber = getDocumentTypeKey(documentType);
      console.log(documentType, documentTypeNumber);

      let q = fc.db.collection(`Companies/${companyID}/Docs`);
      if (documentTypeNumber) {
        q = q.where("@DocType", "==", documentTypeNumber);
      }
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        ">=",
        timeStart.toDate()
      );
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        "<",
        timeEnd.toDate()
      );
      q = q.orderBy(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp")
      );
      return q.get();
    },
    exportDocs() {
      const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00");
      const timeEnd = moment(this.dateExportEnd + "T00:00:00.000+07:00").add(1, "days");
      const filterEmailStatus = this.exportEmailStatusRadios;

      this.getDocsByRange(timeStart, timeEnd).then((querySnapshot) => {
       const rows = [
      [
        "วันที่เอกสาร", // ED.IssueDateTime
        "เลขที่เอกสาร", // objectID
        "รหัสผู้ซื้อ", // SCTT.AHTA.BTP.ID
        "ชื่อผู้ซื้อ/ชื่อบริษัท", // SCTT.AHTA.BTP.Name
        "เลขผู้เสียภาษี", // SCTT.AHTA.BTP.STR.ID
        "สาขาผู้ซื้อ", // @BuyerBranchID
        "มูลค่าที่นำมาคิดภาษี", // SCTT.AHTS.STSHMS.TaxBasisTotalAmount
        "ภาษีมูลค่าเพิ่ม", // SCTT.AHTS.STSHMS.TaxTotalAmount
        "ยอดรวม", // SCTT.AHTS.STSHMS.GrandTotalAmount
        "สถานะการส่งอีเมล", // @MailSent
        "เวลาการส่งอีเมล", // @TimeMailSent
      ],
    ];

    querySnapshot.forEach((doc) => {
      const data = doc.data();

      // Filter by email send status if needed
      if (filterEmailStatus !== "All") {
        if (
          (filterEmailStatus === "Sent" && !data["@MailSent"]) ||
          (filterEmailStatus === "NotSent" && data["@MailSent"])
        ) {
          return;
        }
      }

      rows.push([
        data["ED.IssueDateTime"].split("T")[0],
        data["objectID"],
        data["SCTT.AHTA.BTP.ID"],
        data["SCTT.AHTA.BTP.Name"],
        this.getTaxId(data["SCTT.AHTA.BTP.STR.ID"]),
        data["@BuyerBranchID"],
        libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]),
        libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxTotalAmount"]),
        libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.GrandTotalAmount"]),
        data["@MailSent"] ? "Yes" : "No",
        data["@TimeMailSent"]
          ? moment(data["@TimeMailSent"].toDate()).format("YYYY-MM-DDTHH:mm:ss")
          : "",
      ]);
    });


    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Docs");
    
    XLSX.writeFile(workbook, `Docs_${this.dateExportStart}_${this.dateExportEnd}.xlsx`);

    this.exportDialog = false;
  });
},
    cancelExportDialog() {
      this.exportDialog = false;
    },

    handleImportFile(file) {
  if (file.type !== "text/csv") {
    this.alert = {
      text: "ไม่สามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
      type: "error",
      show: true,
      showOnDialog: true,
    };
    this.$refs.importFileRef.reset();
  } else {
    const reader = new FileReader();

    reader.onload = (event) => {
      const buffer = event.target.result;
      let csvText = "";

      // ลอง decode ด้วย UTF-8 ก่อน (ถ้าไฟล์เป็น UTF-8 จะ decode ได้สำเร็จ)
      try {
        const utf8Decoder = new TextDecoder('utf-8', { fatal: true });
        csvText = utf8Decoder.decode(buffer);
      } catch (e) {
        // ถ้า decode ด้วย UTF-8 ล้มเหลว ให้ fallback ไปใช้ TIS-620
        const tis620Decoder = new TextDecoder('TIS-620');
        csvText = tis620Decoder.decode(buffer);
      }

      // ใช้ Papa.parse ในการแปลง CSV text
      Papa.parse(csvText, {
        header: false,
        skipEmptyLines: true,
        complete: (results) => {
          this.importFile = results;
          // this.parsed = true;
        }
      });
    };

    reader.onerror = () => {
      this.alert = {
        text: "เกิดข้อผิดพลาดในการอ่านไฟล์",
        type: "error",
        show: true,
        showOnDialog: true,
      };
      this.$refs.importFileRef.reset();
    };

    reader.readAsArrayBuffer(file);
  }
  },


  handleImportFileTemp2(type, file) {
  if (file.type !== "text/csv") {
    this.alert = {
      text: "ไม่สามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
      type: "error",
      show: true,
    };

    this.$refs.importFileRefH.reset();
    this.$refs.importFileRefL.reset();
    return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
    const buffer = event.target.result;
    let csvText = "";


    try {
      const utf8Decoder = new TextDecoder("utf-8", { fatal: true });
      csvText = utf8Decoder.decode(buffer);
    } catch (e) {
      const decoder = new TextDecoder("TIS-620");
      csvText = decoder.decode(buffer);
    }

    // Parse the CSV text with Papa Parse.
    Papa.parse(csvText, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        switch (type) {
          case "head":
            this.importFileTemp2Head = results;
            break;
          case "line":
            this.importFileTemp2Line = results;
            break;
        }
      },
    });
  };

  reader.onerror = () => {
    this.alert = {
      text: "เกิดข้อผิดพลาดในการอ่านไฟล์",
      type: "error",
      show: true,
    };

    this.$refs.importFileRefH.reset();
    this.$refs.importFileRefL.reset();
  };

  // อ่านไฟล์ในรูปแบบ ArrayBuffer เพื่อให้สามารถ decode ได้อย่างถูกต้อง
  reader.readAsArrayBuffer(file);
}

,
    async importDocs() {
      let csvData = [];
      var ret = [];
      try {
        switch (this.selectedTemp) {
          case "template-1":
            if (
              this.importFile.data < 0 ||
              typeof this.importFile.data === "undefined" ||
              this.importFile.data == 0 ||
              this.importFile.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV",
                type: "error",
                show: true,
              };
            }

            for (var i = 1; i < this.importFile.data.length; i++) {
              var temp = this.importFile.data[i];

              let Ldiscount = temp[42]
              Ldiscount = Math.abs(Ldiscount)


              var obj = {
                docType: temp[0],
                sellerName: temp[1],
                sellerAddress: temp[2],
                sellerTaxID: temp[3],
                sellerBranchID: temp[4],
                buyerID: temp[5],
                buyerName: temp[6],
                buyerTaxID: temp[7],
                buyerAddress: temp[8],
                buyerBranchID: temp[9],
                buyerEmail: temp[10],
                buyerOrderRefDoc: temp[11],
                issuerAssignedID: temp[12],
                FissueDate: temp[13],
                typeCode: temp[14],
                docID: temp[15],
                issueDate: temp[16],
                creationDate: temp[17],
                noteSubject: temp[18],
                reference: temp[19],
                additionalRefDocs: temp[20],
                LissuerAssignedID: temp[21],
                LissueDate: temp[22],
                LtypeCode: temp[23],
                currency: temp[24],
                vat: temp[25],
                line: temp[26],
                discount: temp[27],
                basis: temp[28],
                tax: temp[29],
                total: temp[30],
                originalinformationamount: temp[31],
                differenceInformationAmount: temp[32],
                purposeCode: temp[33],
                purpose: temp[34],
                items: temp[35],
                productID: temp[36],
                description: temp[37],
                price: temp[38],
                unit: temp[39],
                quantity: temp[40],
                Lvat: temp[41],
                Ldiscount: Ldiscount,
                Lbasis: temp[43],
                Ltax: temp[44],
                Ltotal: temp[45],
                baseInvoiceAmount: temp[46],
                docDueDate: temp[47],
                paymentTermsCode: temp[48],
                customerVendorRef: temp[49],
                downPaymentAmount: temp[50],
                tel1: temp[51],
                tel2: temp[52],
                fax1: temp[53],
                salesEmployeeName: temp[54],
                contactPersonName: temp[55],
                baseRefNo: temp[56],
                baseRefDate: temp[57],
                crReason1: temp[58],
                crReason2: temp[59],
                drReason1: temp[60],
                drReason2: temp[61],
                payBy: temp[62],
                domain: temp[63],
                allowancePercent: temp[64],
              };
              csvData.push(obj);
            }
            var tempCustomer = {};
            for (i = 0; i < csvData.length; i++) {
              var item = csvData[i];
              if (item.sellerName) {
                if (i > 0) {
                  ret.push(tempCustomer);
                }
                tempCustomer = item;
                tempCustomer.items = [];
              } else {
                tempCustomer.items.push(item);
              }
            }

            if (tempCustomer) {
              ret.push(tempCustomer);
            }
            break;
          case "template-2":
            var arrHead = [];
            var arrLine = [];
            if (
              this.importFileTemp2Head.data < 0 ||
              typeof this.importFileTemp2Head.data === "undefined" ||
              this.importFileTemp2Head.data == 0 ||
              this.importFileTemp2Head.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนหัว",
                type: "error",
                show: true,
              };
            } else if (
              this.importFileTemp2Line.data < 0 ||
              typeof this.importFileTemp2Line.data === "undefined" ||
              this.importFileTemp2Line.data == 0 ||
              this.importFileTemp2Line.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
                type: "error",
                show: true,
              };
            }
            // if (this.importFileTemp2Line.data < 0 || typeof this.importFileTemp2Line.data === 'undefined' || this.importFileTemp2Line.data == 0 || this.importFileTemp2Line.data == null) {
            //   this.alert2 = {
            //     text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
            //     type: "error",
            //     show: true
            //   };
            // }
            for (i = 1; i < this.importFileTemp2Head.data.length; i++) {
              var tempHead = this.importFileTemp2Head.data[i];
              var objHead = {
                docType: tempHead[0],
                sellerName: tempHead[1],
                sellerAddress: tempHead[2],
                sellerTaxID: tempHead[3],
                sellerBranchID: tempHead[4],
                buyerID: tempHead[5],
                buyerName: tempHead[6],
                buyerTaxID: tempHead[7],
                buyerAddress: tempHead[8],
                buyerBranchID: tempHead[9],
                buyerEmail: tempHead[10],
                buyerOrderRefDoc: tempHead[11],
                issuerAssignedID: tempHead[12],
                FissueDate: tempHead[13],
                typeCode: tempHead[14],
                docID: tempHead[15],
                issueDate: tempHead[16],
                creationDate: tempHead[17],
                noteSubject: tempHead[18],
                reference: tempHead[19],
                additionalRefDocs: tempHead[20],
                LissuerAssignedID: tempHead[21],
                LissueDate: tempHead[22],
                LtypeCode: tempHead[23],
                currency: tempHead[24],
                vat: tempHead[25],
                line: tempHead[26],
                discount: tempHead[27],
                basis: tempHead[28],
                tax: tempHead[29],
                total: tempHead[30],
                originalinformationamount: tempHead[31],
                differenceInformationAmount: tempHead[32],
                purposeCode: tempHead[33],
                purpose: tempHead[34],
                //line
                items: "",
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: tempHead[35] || "",
                docDueDate: tempHead[36] || "",
                paymentTermsCode: tempHead[37] || "",
                customerVendorRef: tempHead[38] || "",
                downPaymentAmount: tempHead[39] || "",
                tel1: tempHead[40] || "",
                tel2: tempHead[41] || "",
                fax1: tempHead[42] || "",
                salesEmployeeName: tempHead[43] || "",
                contactPersonName: tempHead[44] || "",
                baseRefNo: tempHead[45] || "",
                baseRefDate: tempHead[46] || "",
                crReason1: tempHead[47] || "",
                crReason2: tempHead[48] || "",
                drReason1: tempHead[49] || "",
                drReason2: tempHead[50] || "",
                payBy: tempHead[51] || "",
                domain: tempHead[52] || "",
                allowancePercent: tempHead[53] || "",
              };
              arrHead.push(objHead);
            }

            for (i = 1; i < this.importFileTemp2Line.data.length; i++) {
              var tempLine = this.importFileTemp2Line.data[i];



              let Ldiscount = tempLine[8]
              Ldiscount = Math.abs(Ldiscount)

              var objLine = {
                docType: "",
                sellerName: "",
                sellerAddress: "",
                sellerTaxID: "",
                sellerBranchID: "",
                buyerID: "",
                buyerName: "",
                buyerTaxID: "",
                buyerAddress: "",
                buyerBranchID: "",
                buyerEmail: "",
                buyerOrderRefDoc: "",
                issuerAssignedID: "",
                FissueDate: "",
                typeCode: "",
                docID: tempLine[0],
                issueDate: "",
                creationDate: "",
                noteSubject: "",
                reference: "",
                additionalRefDocs: "",
                LissuerAssignedID: "",
                LissueDate: "",
                LtypeCode: "",
                currency: "",
                vat: "",
                line: "",
                discount: "",
                basis: "",
                tax: "",
                total: "",
                originalinformationamount: "",
                differenceInformationAmount: "",
                purposeCode: "",
                purpose: "",
                //line
                items: tempLine[1],
                productID: tempLine[2],
                description: tempLine[3],
                price: tempLine[4],
                unit: tempLine[5],
                quantity: tempLine[6],
                Lvat: tempLine[7],
                Ldiscount: Ldiscount,
                Lbasis: tempLine[9],
                Ltax: tempLine[10],
                Ltotal: tempLine[11],
                //
                baseInvoiceAmount: "",
                docDueDate: "",
                paymentTermsCode: "",
                customerVendorRef: "",
                downPaymentAmount: "",
                tel1: "",
                tel2: "",
                fax1: "",
                salesEmployeeName: "",
                contactPersonName: "",
                baseRefNo: "",
                baseRefDate: "",
                crReason1: "",
                crReason2: "",
                drReason1: "",
                drReason2: "",
                payBy: "",
                domain: "",
              };
              arrLine.push(objLine);
            }
            console.log("arrLine===>", arrLine);
            arrHead.forEach((listHead) => {
              var itemList = arrLine.filter(
                (arrLine) => arrLine.docID == listHead.docID
              );
              var obj2 = {
                docType: listHead.docType,
                sellerName: listHead.sellerName,
                sellerAddress: listHead.sellerAddress,
                sellerTaxID: listHead.sellerTaxID,
                sellerBranchID: listHead.sellerBranchID,
                buyerID: listHead.buyerID,
                buyerName: listHead.buyerName,
                buyerTaxID: listHead.buyerTaxID,
                buyerAddress: listHead.buyerAddress,
                buyerBranchID: listHead.buyerBranchID,
                buyerEmail: listHead.buyerEmail,
                buyerOrderRefDoc: listHead.buyerOrderRefDoc,
                issuerAssignedID: listHead.issuerAssignedID,
                FissueDate: listHead.FissueDate,
                typeCode: listHead.typeCode,
                docID: listHead.docID,
                issueDate: listHead.issueDate,
                creationDate: listHead.creationDate,
                noteSubject: listHead.noteSubject,
                reference: listHead.reference,
                additionalRefDocs: listHead.additionalRefDocs,
                LissuerAssignedID: listHead.LissuerAssignedID,
                LissueDate: listHead.LissueDate,
                LtypeCode: listHead.LtypeCode,
                currency: listHead.currency,
                vat: listHead.vat,
                line: listHead.line,
                discount: listHead.discount,
                basis: listHead.basis,
                tax: listHead.tax,
                total: listHead.total,
                originalinformationamount: listHead.originalinformationamount,
                differenceInformationAmount:
                  listHead.differenceInformationAmount,
                purposeCode: listHead.purposeCode,
                purpose: listHead.purpose,
                //line
                items: itemList,
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: listHead.baseInvoiceAmount,
                docDueDate: listHead.docDueDate,
                paymentTermsCode: listHead.paymentTermsCode,
                customerVendorRef: listHead.customerVendorRef,
                downPaymentAmount: listHead.downPaymentAmount,
                tel1: listHead.tel1,
                tel2: listHead.tel2,
                fax1: listHead.fax1,
                salesEmployeeName: listHead.salesEmployeeName,
                contactPersonName: listHead.contactPersonName,
                baseRefNo: listHead.baseRefNo,
                baseRefDate: listHead.baseRefDate,
                crReason1: listHead.crReason1,
                crReason2: listHead.crReason2,
                drReason1: listHead.drReason1,
                drReason2: listHead.drReason2,
                payBy: listHead.payBy,
                domain: listHead.domain,
              };
              ret.push(obj2);
            });
            break;
        }
        console.log("ret ==>", ret);
        if (ret.length > 0) {
          let companyID = this.$route.params.companyId;
          await this.$store.dispatch("importDocs/importDocs", {
            docs: ret,
            companyID,
          });
          this.alert = {
            text: "นำเข้าข้อมูล สําเร็จ หน้าเว็บจะรีโหลดในอีก 3 วิ",
            type: "success",
            show: true,
            showOnDialog: true,
          };
          // setTimeout(()=> this.cancelImportDialog(),1000);
          setTimeout(() => window.location.reload(), 3000);
        }
      } catch (error) {
        console.log("File import error " + error.toString());
        this.alert = {
          text: "นำเข้าข้อมูล ไม่สําเร็จ",
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    },
    cancelImportDialog() {
      this.importDialog = false;
      this.importFile = [];
      this.template1 = null;
      this.templateh = null;
      this.templatel = null;
      this.alert = {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      };
      //this.$refs.importFileRef.value=null
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList);
      if (checked) {
        docs.state.list.forEach((doc) => {
          if (!selectedList.some((x) => x["docID"] === doc.id)) {
            selectedList.push({
              companyID: this.companyID,
              docID: doc.id,
              pdfUrl: doc["@SignedPdfUrl"],
              xmlUrl: doc["@SignedXmlUrl"],
              downloadedXml: doc["@DownloadedXml"],
              buyerEmail: doc["@BuyerEmail"],
              taxRisPayload: {
                HASH_KEY: "4Z79Dkk13fGwfrxNhc2GgPHec6giw96VLrY9evrNHfo=",
                CrsPfms: {
                  // TIN: doc["SCTT.AHTA.STP.STR.ID"]?.slice(0, 12),
                  // TIN: "644106815000",
                  TIN: "002012567000",
                  INV_NO: doc["ED.ID"],
                  INV_DD: this.formatedDateTaxRIS(doc["ED.IssueDateTime"]),
                  BY_TIN: doc["SCTT.AHTA.BTP.STR.ID"]?.slice(0, 12),
                  BY_FULL_NM: doc["SCTT.AHTA.BTP.Name"],
                  SALE_CNT: doc["SCTT.ISCTLI"] ? doc["SCTT.ISCTLI"].length : 0,
                  SUPL_AMT: doc["SCTT.AHTS.ATT.BasisAmount"],
                  SVC_FEE: doc["SCTT.AHTS.STSHMS.TaxTotalAmount"],
                  EXCISE_AMT: 0,
                  VAT_AMT: doc["SCTT.AHTS.STSHMS.TaxTotalAmount"],
                  SALE_AMT: doc["SCTT.AHTS.STSHMS.GrandTotalAmount"],
                  DISC_AMT: doc["SCTT.AHTS.STSHMS.AllowanceTotalAmount"],
                  SALE_CNCL_CNT: 0,
                  SALE_CNCL_AMT: 0,
                  list: doc["SCTT.ISCTLI"]
                    ? doc["SCTT.ISCTLI"].map((item) => ({
                        HS_CD: item["STP.ID"],
                        HS_NM: item["STP.Name"],
                        SALE_CNT: item["SLTD.BilledQuantity"],
                        UNIT_SALE: item["SLTD.BilledQuantity.unitCode"],
                        UNIT_SALE_AMT: item["SLTA.GPPTP.ChargeAmount"],
                        SUPL_AMT: item["SLTS.STSLMS.NetLineTotalAmount"],
                        EXCISE_AMT: "0",
                        VAT_AMT: item["SLTS.STSLMS.TaxTotalAmount"],
                        SALE_AMT:
                          item["SLTS.STSLMS.NetIncludingTaxesLineTotalAmount"],
                      }))
                    : [],
                },
              },
            });
          }
        });
      } else {
        docs.state.list.forEach((doc) => {
          let index = selectedList.findIndex((x) => x["docID"] === doc.id);
          if (index !== -1) {
            selectedList.splice(index, 1);
          }
        });
      }
      this.$store.dispatch("docs/setSelectedList", {
        selectedList: selectedList,
      });
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList);
      if (this.getCheckedSelect(doc.id)) {
        let index = valueList.findIndex((x) => x["docID"] === doc.id);
        valueList.splice(index, 1);
      } else {
        valueList.push({
          companyID: this.companyID,
          docID: doc.id,
          pdfUrl: doc["@SignedPdfUrl"],
          xmlUrl: doc["@SignedXmlUrl"],
          downloadedXml: doc["@DownloadedXml"],
          buyerEmail: doc["@BuyerEmail"],
          taxRisPayload: {
            HASH_KEY: "4Z79Dkk13fGwfrxNhc2GgPHec6giw96VLrY9evrNHfo=",
            CrsPfms: {
              // TIN: doc["SCTT.AHTA.STP.STR.ID"]?.slice(0, 12),
              //TIN: "644106815000",
              TIN: doc["TIN"],
              INV_NO: doc["ED.ID"],
              INV_DD: this.formatedDateTaxRIS(doc["ED.IssueDateTime"]),
              BY_TIN: doc["SCTT.AHTA.BTP.STR.ID"]?.slice(0, 12),
              BY_FULL_NM: doc["SCTT.AHTA.BTP.Name"],
              SALE_CNT: doc["SCTT.ISCTLI"] ? doc["SCTT.ISCTLI"].length : 0,
              SUPL_AMT: doc["SCTT.AHTS.ATT.BasisAmount"],
              SVC_FEE: doc["SCTT.AHTS.STSHMS.TaxTotalAmount"],
              EXCISE_AMT: 0,
              VAT_AMT: doc["SCTT.AHTS.STSHMS.TaxTotalAmount"],
              SALE_AMT: doc["SCTT.AHTS.STSHMS.GrandTotalAmount"],
              DISC_AMT: doc["SCTT.AHTS.STSHMS.AllowanceTotalAmount"],
              SALE_CNCL_CNT: 0,
              SALE_CNCL_AMT: 0,
              list: doc["SCTT.ISCTLI"]
                ? doc["SCTT.ISCTLI"].map((item) => ({
                    HS_CD: item["STP.ID"],
                    HS_NM: item["STP.Name"],
                    SALE_CNT: item["SLTD.BilledQuantity"],
                    UNIT_SALE: item["SLTD.BilledQuantity.unitCode"],
                    UNIT_SALE_AMT: item["SLTA.GPPTP.ChargeAmount"],
                    SUPL_AMT: item["SLTS.STSLMS.NetLineTotalAmount"],
                    EXCISE_AMT: "0",
                    VAT_AMT: item["SLTS.STSLMS.TaxTotalAmount"],
                    SALE_AMT:
                      item["SLTS.STSLMS.NetIncludingTaxesLineTotalAmount"],
                  }))
                : [],
            },
          },
        });
      }

      this.$store.dispatch("docs/setSelectedList", { selectedList: valueList });
      this.currentXmlUrl = doc["@SignedXmlUrl"];
    },
    checkSelectedAll: function () {
      let selectedAll = false;
      let checkCount = 0;
      this.selectedList.forEach((select) => {
        if (docs.state.list.some((doc) => doc.id === select.docID)) {
          checkCount++;
        }
      });
      if (checkCount === docs.state.list.length && docs.state.list.length > 0) {
        selectedAll = true;
      }
      this.selectedAll = selectedAll;
    },
    debounceInput: _.debounce(function (keyword) {
      this.changeKeyword(keyword);
    }, 1000),
    changeKeyword: function (keyword) {
      this.clearValue();
      let companyId = this.$route.params.companyId;

      if (companyId) {
        this.$store.dispatch("docs/updateKeyword", {
          id: companyId,
          keyword: keyword,
        });

        this.query();
        let resizeId;
        window.addEventListener("resize", () => {
          clearTimeout(resizeId);
          resizeId = setTimeout(this.handleResize, 100);
        });
        this.handleResize();
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false;
        this.sendEmail();
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true;

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };

      const promises = Object.keys(this.emailList).map(async (k) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: k,
          email: this.emailList[k].join(","),
        };

        if (this.mEmailTemplateID != "Default Template") {
          data["emailTemplateID"] = this.mEmailTemplateID;
        }

        await axios
          .post(fc.cloudFunctionUrl + "sendemail", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                this.sendEmailSuccessCount++;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      });

      await Promise.all(promises);
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = {
          text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ",
          type: "success",
          show: true,
        };

        this.sendEmailSuccessCount = 0;

        this.query();
      }
      this.sendEmailLoading = false;
      this.emailDialog = false;
      this.email = "";
      this.emailList = {};
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect);
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" };
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc");
        } else {
          orderBySelect = {};
        }
      }
      this.$store.dispatch("docs/setOrderBySelect", {
        orderBySelect: orderBySelect,
      });
      this.$store.dispatch("docs/updatePage", { page: 1 });
      this.query();
    },
    downloadPDF: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      this.downloadZip("pdf", this.selectedList, "pdf", MAX_DOC_PER_ZIP["pdf"]);
    },
    downloadMonthly: async function ({ month, fileType, filter }) {
      let maxPerZip = MAX_DOC_PER_ZIP[fileType] || 0;

      try {
        this.loadingDownloadZip("monthly", "on");
        this.setDownloadProgress("monthly", "");
        const startDate = moment(month).startOf("day");
        const endDate = moment(month).endOf("month").endOf("day");
        const snapshot = await this.getDocsByRange(startDate, endDate);

        let selected = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          selected.push({
            docID: doc.id,
            pdfUrl: data["@SignedPdfUrl"],
            xmlUrl: data["@SignedXmlUrl"],
            downloadedXml: data["@DownloadedXml"],
          });
        });

        if (filter) {
          if (filter.downloadedXml === "Downloaded") {
            selected = selected.filter((doc) => doc.downloadedXml);
          } else if (filter.downloadedXml === "NotDownloaded") {
            selected = selected.filter((doc) => !doc.downloadedXml);
          }
        }

        await this.downloadZip(fileType, selected, "monthly", maxPerZip);
      } catch (err) {
        this.loadingDownloadZip("monthly", "off");
      }
    },
    downloadXML: function () {
      this.downloadZip("xml", this.selectedList, "xml", MAX_DOC_PER_ZIP["xml"]);
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on";
      if (type === "xml")
        this.$store.dispatch("docsDownloaded/updateDownloadingXml", {
          downloadingXml: boolean,
        });
      else if (type === "pdf")
        this.$store.dispatch("docsDownloaded/updateDownloadingPdf", {
          downloadingPdf: boolean,
        });
      else
        this.$store.commit("docsDownloaded/setDownloading", {
          type: type,
          downloading: boolean,
        });
    },
    setDownloadProgress: function (type, progress) {
      this.$store.commit("docsDownloaded/setDownloadProgress", {
        type: type,
        progress: progress,
      });
    },
    downloadZip: async function (type, selected, loadingType, maxPerZip) {
      if (!loadingType) {
        loadingType = type;
      }

      this.loadingDownloadZip(loadingType, "on");
      let urlField = "pdfUrl";
      if (type === "xml") {
        urlField = "xmlUrl";
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let docList = [];
      let timeStamp = new Date().getTime();

      // เอาเฉพาะแถวที่มี url
      selected.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["docID"], url: docSelect[urlField] });
        }
      });

      if (docList.length === 0) {
        this.loadingDownloadZip(loadingType, "off");
        this.alert = {
          text: "ไม่พบเอกสารที่ต้องการ",
          type: "error",
          show: true,
        };
        return;
      }

      if (!maxPerZip) {
        maxPerZip = docList.length;
      }

      const companyId = this.$route.params.companyId;
      const zipChunk = async function (chunk, startNumber) {
        const result = await axios.post(
          fc.cloudFunctionUrl + "zipFiles",
          { data: chunk, type: type, companyID: companyId },
          { headers, responseType: "arraybuffer" }
        );
        if (result.data.byteLength !== 0) {
          let url = URL.createObjectURL(
            new Blob([result.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${timeStamp}_${startNumber}-${startNumber + chunk.length - 1}.zip`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
      };

      // split documents into smaller chunks
      // then zip and download each
      let startNumber = 1;
      const total = docList.length;
      while (docList.length > 0) {
        try {
          const chunk = docList.splice(0, maxPerZip);
          this.setDownloadProgress(
            loadingType,
            `กำลังโหลด...(${startNumber - 1}/${total})`
          );
          await zipChunk(chunk, startNumber);
          startNumber += chunk.length;
        } catch (err) {
          console.log("front end error: ", err);
          this.alert = {
            text: "เกิดข้อผิดพลาดขณะดาวน์โหลด กรุณาลองอีกครั้ง",
            type: "error",
            show: true,
          };
          this.loadingDownloadZip(loadingType, "off");
          return;
        }
      }

      this.loadingDownloadZip(loadingType, "off");
      this.clearSelectList();
    },
    clearDownloadedXml: async function () {
      this.clearingDownloadedXml = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList.filter((doc) => doc.downloadedXml);
      const count = list.length;
      const batch = fc.db.batch();

      list.forEach((doc) => {
        const docRef = fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`);
        batch.update(docRef, {
          "@DownloadedXml": false,
        });
      });

      try {
        await batch.commit();
        this.alert = {
          text: "ยกเลิกค่าดาวน์โหลดสำเร็จ " + count + " รายการ",
          type: "success",
          show: true,
        };
      } catch (err) {
        console.error("clearDownloadedXml error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะยกเลิกค่าดาวน์โหลด กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.clearSelectList();
      this.clearingDownloadedXml = false;
    },
    onClickDocId: async function (doc) {
      this.$store.dispatch("setGlobalLoading", true);
      this.downloadPdfLoading = true;

      let pdfLink = doc["@SignedPdfUrl"];
      console.log("Doc Clicked, PDF LINK::  ", pdfLink);
      if (!pdfLink) {
        this.alert = {
          text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["objectID"],
          type: "error",
          show: true,
        };
      }
      let unsigedPdfLink = doc["@UnsignedPdfUrl"];

      let link = "";
      if (!pdfLink && !unsigedPdfLink) {
        link = await this.updateUnsignedPdf(doc["objectID"]);
      } else if (pdfLink) {
        link = pdfLink;
      } else if (unsigedPdfLink) {
        link = unsigedPdfLink;
      }

      console.log("linkk:: ", link);

      if (!this.pdfDialog && link) {
        await axios
          .get(link, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              this.downloadPdfLoading = false;

              let url = URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
              );

              if (isMobile()) {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "invoice_" + new Date().getTime() + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
              } else {
                this.pdfSrc = url;
                this.pdfDialog = true;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
      this.$store.dispatch("setGlobalLoading", false);
    },
    updateUnsignedPdf: async function (docID) {
      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      };
      const promise = new Promise((resolve, reject) => {
        axios
          .post(fc.cloudFunctionUrl + "updateUnsignedPdf", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
              this.$store.dispatch("setGlobalLoading", false);
              this.downloadPdfLoading = false;
            }
          );
      });
      return promise;
    },
    getDateWithFormat: function (date) {
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },
    onChangeValueFilterList(value) {
      this.clearValue();
      this.$store.dispatch("docs/setValueFilterList", {
        valueFilterList: value,
      });
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value;
    },
    onChangeValueSearchOption(value) {
      console.log("onChangeValueSearchOption Triggerrd:: ", value);
      this.defaultSearchOptionValue = value;
      this.$store.dispatch("docs/setSearchField", value);
      this.query();
    },
    showColumn(field) {
      return this.valueHideList.includes(field);
    },
    clearValue: function () {
      this.$store.dispatch("docs/updatePage", { page: 1 });
    },
    clearSelectList: function () {
      this.$store.dispatch("docs/setSelectedList", { selectedList: [] });
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors);
    },
    clearAllSelectList: function () {
      this.selectAll = false;
      this.$store.dispatch("docs/setSelectedList", { selectedList: [] });
      this.clearSelectList();
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status);
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = "";
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value));
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]];
      Vue.observable(this.emailList[k]);
    },
    resetDateSearch: function () {
      this.$store.dispatch("docs/setFromDate", "");
      this.$store.dispatch("docs/setToDate", "");
      this.$store.dispatch("docs/updateKeyword", "");
      this.fromDateVal = null;
      this.toDateVal = null;
      this.clearValue();
    },
  },
};
</script>

<style lang="scss">
#table-firebase {
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  .v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 270px;
  }

  .search-box {
    width: 250px;
  }

  .remove-checkbox-padding {
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }

  .icon-button {
    height: -webkit-fill-available;
  }
}

.numberRow {
  min-width: 3rem !important;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}

.v-btn {
  letter-spacing: unset !important;
}

.btn-choose {
  margin-right: 20px;
}

.btn-submit {
  margin-right: 20px;
}
</style>
